
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { type WideCardType } from '@xt/client/types/home.d'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import HeadCard from './card/headCard.vue'
import WideCard from './card/wideCard.vue'
import lodash from 'lodash'

@Component({
  components: {
    WideCard,
    HeadCard,
    NewSwiper
  }
})
export default class extends Vue {
  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  activeIndex: number = 0

  get dataSource() {
    return this.$store.$homeV2.dataSource?.registrationRecommend
  }

  get dataList(): WideCardType[][] {
    return lodash.chunk(this.dataSource?.list, 4)
  }

  handleChange(index) {
    this.activeIndex = index
  }

  prev() {
    if (!this.swiper) return

    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return

    this.swiper.handleNext()
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
